import React, { useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaTrash } from 'react-icons/fa';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import * as api from '~/Services/Service';
import ModalAdicionarListaNegra from '../Modais/ModalAdicionarListaNegra';

const TabListaNegra = (props) => {
  const parceria = props.parceria;
  const onAlterado = props.onAlterado;
  const listaNegra = (parceria && parceria.lista_negra) || [];

  const [showModal, setShowModal] = useState(false);
  const [confirmacao, setConfirmacao] = useState({ show: false, item: null });

  const handleExcluir = (item) => {
    setConfirmacao({ show: true, item: item });
  };

  const handleConfirmarExclusao = async (confirmado) => {
    const item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    if (!confirmado || !item) return;
    try {
      await api.excluirListaNegraParceria({
        codigo_parceria: parceria.codigo_parceria,
        codigo_grupo_empresa: item.codigo_grupo_empresa,
        codigo_conta: item.codigo_conta,
      });
      toast.success('Conta removida da lista negra com sucesso');
      await onAlterado();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao remover conta da lista negra');
    }
  };

  return (
    <div>
      <p className="text-muted mb-2" style={{ fontSize: '0.875rem' }}>
        Contas internas <strong>bloqueadas</strong> para esta parceria.
      </p>

      <div className="text-right mb-3">
        <Button variant="primary" onClick={() => setShowModal(true)}>
          + Adicionar Conta
        </Button>
      </div>

      {listaNegra.length === 0 ? (
        <p className="text-muted text-center my-3">Nenhuma conta bloqueada cadastrada.</p>
      ) : (
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th>GE</th>
              <th>Conta Interna</th>
              <th>Apelido</th>
              <th style={{ width: '80px', textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {listaNegra.map((item) => (
              <tr key={item.codigo_grupo_empresa + '-' + item.codigo_conta}>
                <td>{item.codigo_grupo_empresa}</td>
                <td>{item.codigo_conta}</td>
                <td>{item.apelido_conta}</td>
                <td className="text-center">
                  <Button
                    variant="outline-danger"
                    title="Remover"
                    onClick={() => handleExcluir(item)}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <ModalAdicionarListaNegra
        show={showModal}
        onHide={() => setShowModal(false)}
        codigoParceria={parceria.codigo_parceria}
        onSalvo={async () => {
          setShowModal(false);
          await onAlterado();
        }}
      />

      <ModalConfirmacao
        show={confirmacao.show}
        title="Remover da Lista Negra"
        message={
          confirmacao.item
            ? 'Deseja remover a conta ' + confirmacao.item.codigo_conta + (confirmacao.item.apelido_conta ? ' — ' + confirmacao.item.apelido_conta : '') + ' da lista negra?'
            : ''
        }
        onClose={handleConfirmarExclusao}
      />
    </div>
  );
};

export default TabListaNegra;
